import React from 'react';

/**
 * Only use when there is a markdown link that needs the target="_blank" property set.
 */
export const LinkRenderer = (
  props: React.AnchorHTMLAttributes<HTMLAnchorElement>,
): React.ReactElement => {
  const { href, children } = props;
  return (
    <a href={href} target="_blank" rel="noreferrer">
      {children}
    </a>
  );
};
